import type { ReactNode } from 'react';

import Icon from '../Icon';

import './Note.scss';

/** Пропсы внутриблочной подсказки Note. */
export interface NoteProps {
  /** info — серая подсказка; warning — рамка $warning и иконка треугольника */
  variant?: 'info' | 'warning';
  /** Имя иконки (Icon). По умолчанию: warning — exclamation-triangle, info — без иконки. */
  icon?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Компактная подсказка внутри блока: серый прямоугольник (info) или
 * предупреждение с рамкой и иконкой (warning). Выделено из мастера ШМ
 * (tfw-section-note / tfw-note-warning) в коллекцию ui.
 */
const Note = ({ variant = 'info', icon, className, children }: NoteProps) => {
  const iconName = icon ?? (variant === 'warning' ? 'exclamation-triangle' : null);

  return (
    <div className={ `note note-${ variant }${ className ? ` ${ className }` : '' }` }>
      { iconName && <Icon name={ iconName } /> }
      <span>{ children }</span>
    </div>
  );
};

export default Note;
